import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { MaterialAsphaltProduct } from '@src/types/MaterialAsphaltProduct'
import { TransportTypeId } from '@src/types/TransportTypeId'

interface Options  {
  srrId: number | string,
  serialId: number,
  transportTypeId: TransportTypeId,
  partial: Partial<MaterialAsphaltProduct>,
}

export const apiSrrTransportUpdate = (options: Options) => {
  const { 
    srrId, 
    serialId,
    transportTypeId,
    partial,
  } = options

  const data = {
    srrId,
    transportType: {
      id: transportTypeId,
    },
    ...partial,
  }
  const axOptions = {
    method: 'PUT',
    url: `${BASE_API_URL}/v2/srr/${srrId}/machine/transport/details/${partial.id}`,
    data,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}